import module from 'fanconsultores/module.js'
import template from './template.html'

class FanconsultoresAdminAppErrorComponent {
  constructor ($scope, $state) {
    this.$scope = $scope
    this.$state = $state
    this.error = null
    this.onClose = null
    this.appError = null
    this.mostrarError = false
  }

  $onInit () {
    this.$scope.$watch(() => this.appError.$error, ($error) => {
      if ($error) {
        this.error.open()
      } else {
        this.error.close()
      }
    })
  }

  cerrar () {
    if (this.$state.current.name === '') {
      this.$state.go('admin.welcome')
    }

    this.appError.$error = null
  }
}

module.component('fanconsultoresAdminAppError', {
  controller: FanconsultoresAdminAppErrorComponent,
  template,
  bindings: {
    error: '<',
    onClose: '&',
  },
  require: {
    appError: '^appError',
  },
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/fanconsultores/admin/app/error/component.js